
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"30","viewBox":"0 0 46 30","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.152 29.89H.784A.784.784 0 010 29.106V.893C0 .46.35.11.784.11h14.368V29.89z","fill":"#41479B"}}),_c('path',{attrs:{"d":"M30.304.11H15.152v29.78h15.152V.11z","fill":"#F5F5F5"}}),_c('path',{attrs:{"d":"M44.672 29.89H30.305V.11h14.367c.433 0 .784.35.784.783v28.213c0 .433-.35.784-.784.784z","fill":"#FF4B55"}})])
          )
        }
      }
    